export default "__VITE_ASSET__CRTqr6m4__"